import actionCreator from '@/helpers/redux/actionCreator';

export const REDIRECT_ACTION = '@/REDIRECT_ACTION';

export const redirectAction = redirectUrl => actionCreator(REDIRECT_ACTION, { redirectUrl });
